<template>
    <div class="nav-box">
        <leftRightSlide :tabNav="navDataArr" :showOrFalse="index == ind" @compute="compute(index)" @changeCon="getContent" @refresh="refresh"></leftRightSlide>
        <div class="category">
            <div class="second"
                    v-for="(ite,ind) in content"
                    :key="ind">
                <div class="title" :style="'width:'+ maxWidth + 'px;'" :itemId="item.id" :iteId="ite.id" :iteAppId="ite.appId" :iteName="ite.name"><a href="javascript:;" class="fr"
                    @click="jump($event,item.id,ite.id,ite.id,ite.appId,ite.name)">{{ite.name}} :</a>
                </div>
                <div class="cont">
                    <span v-for="(t,i) in ite.dataArray"
                        :key="i"
                        class="block"
                        @click="jump($event,item.id,ite.id,t.id,t.appId,t.name,t.pageUrl)">{{t.name}}
                        <!-- <a href="javascript:;"
                            @click="jump($event,item.id,ite.id,t.id,t.appId,t.name,t.pageUrl)">{{t.name}}</a> -->
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import leftRightSlide from './leftRightSlide.vue';
export default {
    name:"topTab",
    components:{
      leftRightSlide
    },
    props:{
        item:Object,
        index:Number,
        ind:Number
    },
    data(){
        return{
            content:[],
            navDataArr:this.item.navDataArr,
            maxWidth:50
        }
    },
    mounted(){
        window.launch = this.launch;
        window.retract = this.retract;
        this.getContent(this.item.navDataArr[0].id);
    },
    methods:{
        //跳转页面
        jump (e, id1, id2, id3,appIdStr,name,wzUrl) {
            e.preventDefault();
            e.stopPropagation();
            if(id3 == 'falseBlockId'){
                this.open(wzUrl, '_self');
                return;
            }
            this.routerJump('push','flowList',{ appId: this.$appId, id1: id1 ? id1 : '', id2: id2 ? id2 : '', id3: id3 ? id3 : '',appIdStr: appIdStr},name);
        },
        refresh(){
            this.getContent(this.item.navDataArr[0].id);
            this.navDataArr = [];
            this.$nextTick(()=>{
                this.navDataArr=this.item.navDataArr;
            });
        },
        //排序
        sortTags (arr) {
            const _this = this;
            let cloneArr = arr.sort((a, b) => {
                return (b.length - a.length);
            })
            return cloneArr;
        },
        getContent(id){
            //获取浮层内容
            this.$http
                .get("/zciid-deliverable/api/showPlatform/content/getSubordinateContentByFlowId.json", {
                    appId: this.$appId,
                    flowId: id
                }).then(res => {
                    if (res.state == 1) {
                        this.content = res.data;
                        var arr = [];
                        res.data.forEach((item,ind)=>{
                          arr.push(item.name);
                        })
                        //计算最大宽度
                        this.maxWidth = (this.sortTags(arr)[0].length + 1) * 12 + 2;
                        this.$nextTick(()=>{
                            this.compute(this.index,'resh',id);
                        })
                    }
                })
        },
        launch(e,that){
            //展开
            e.stopPropagation();
            var ite = $(that).parent().prev();
            this.jump(e,ite.attr('itemId'),ite.attr('iteId'),ite.attr('iteId'),ite.attr('appId'),ite.attr('name'));
            // $(that).addClass('hide');
            // $(that).siblings().removeClass('hide');
        },
        retract(e,that){
            //收起
            e.stopPropagation();
            $(that).parent().find('.more').removeClass('hide');
            $(that).parent().find('.more').nextAll().addClass('hide');
        },
        compute(ind,resh,id){
            if(resh && this.item.navDataArr[0].id != id){
                //点击请求的时候才清除
                $('#enterprise-banner .category:eq('+ ind +')').find('.more,.packup').remove();
            }
            //显示浮层时触发
            const spans = Array.from(document.querySelectorAll('#enterprise-banner .category')[ind].children);
            spans.forEach((ele,i)=>{
                var index = this.getFirstElementOfEachLine(ele);
                if(index){
                    $(ele).find('.more,.packup').remove();
                    if(!ele.querySelector('.packup')){
                        ele.querySelector('.cont').insertAdjacentHTML("beforeend",'<span class="packup" onclick="retract(event,this)">收起 <<</span>');
                    }
                    if(!ele.querySelector('.more')){
                        ele.querySelectorAll('span')[index].insertAdjacentHTML("beforebegin",'<span class="more" onclick="launch(event,this)">更多 >></span>');
                        ele.querySelectorAll('span').forEach((tag,g) => {
                            if(g > index){
                                tag.classList.add("hide");
                            }
                        })
                    }
                }
            })
        },
        getFirstElementOfEachLine(container){
            //获取第三行第一个index
            const spans = Array.from(container.getElementsByTagName('span'));
            let lineHeights = [];
            
            spans.forEach((span, index) => {
                const rect = span.getBoundingClientRect();
                
                if (index === 0 || (rect.top && rect.top == spans[index - 1].getBoundingClientRect().bottom)) {
                lineHeights.push(index);
                }
            });
            if(lineHeights.length > 2){
                return lineHeights[2] -1 
            }
            return 0;
        }
    }
}
</script>
<style scoped>
#enterprise-banner .left-box .first .nav-box {
  width: 799px;
  height: 340px;
  background: #fff;
  position: absolute;
  top: -1px;
  left: 182px;
  display: block;
  z-index: 999;
  padding: 0 10px 20px 0;
  overflow-y: auto;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
}
#enterprise-banner .left-box .first .nav-box .category {
  line-height: 30px;
  margin: 10px 0 0 20px;
}

#enterprise-banner .left-box .first .nav-box .category .second {
  border-bottom: 1px dashed #ddd;
  margin-bottom: 5px;
  margin-top: 10px;
  display: flex;
}

#enterprise-banner .left-box .first .nav-box .category .second .block:hover {
  color: #0d78cf;
}
#enterprise-banner .left-box .first .nav-box .category .second span {
  padding-right: 20px;
  word-break: break-word;

  display: inline-block;
}
#enterprise-banner .left-box .first .nav-box .category .second .title {
  padding-right: 20px;
  width: 300px;
  line-height: 30px;
  height: 30px;
  flex: none;
}
#enterprise-banner .left-box .first .nav-box .category .second .title a {
  font-size: 12px;
  color: #333333;
  font-weight: 600;
}
</style>


// WEBPACK FOOTER //
// src/components/navbox.vue